
import { motion } from "framer-motion";
import { Sparkles, Rocket, ChefHat } from "lucide-react";

export const HowItWorks = () => {
  return (
    <motion.div 
      className="mt-20 text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
    >
      <h2 className="text-4xl font-bold mb-12 text-white">
        Turn Any Recipe into a Fun Learning Adventure!
      </h2>
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto px-4">
        <motion.div 
          className="bg-white/90 backdrop-blur-sm p-8 rounded-xl shadow-xl"
          whileHover={{ y: -5, scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <div className="relative mb-6">
            <div className="absolute -top-12 left-1/2 transform -translate-x-1/2">
              <motion.div
                animate={{ y: [0, -5, 0] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="w-16 h-16 bg-primary rounded-full flex items-center justify-center shadow-lg"
              >
                <span className="text-3xl">1️⃣</span>
              </motion.div>
            </div>
          </div>
          <h3 className="text-xl font-bold mb-4 text-primary">Find Any Recipe</h3>
          <p className="text-gray-600">
            Got a favorite recipe? Just paste the link! We'll transform it into an exciting kid-friendly adventure.
          </p>
          <motion.div
            className="mt-4"
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            <Sparkles className="w-8 h-8 mx-auto text-primary opacity-75" />
          </motion.div>
        </motion.div>

        <motion.div 
          className="bg-white/90 backdrop-blur-sm p-8 rounded-xl shadow-xl"
          whileHover={{ y: -5, scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <div className="relative mb-6">
            <div className="absolute -top-12 left-1/2 transform -translate-x-1/2">
              <motion.div
                animate={{ y: [0, -5, 0] }}
                transition={{ duration: 2, repeat: Infinity, delay: 0.3 }}
                className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center shadow-lg"
              >
                <span className="text-3xl">2️⃣</span>
              </motion.div>
            </div>
          </div>
          <h3 className="text-xl font-bold mb-4 text-secondary">Magic Transformation</h3>
          <p className="text-gray-600">
            Watch as we add fun science facts, helpful tips, and safety reminders perfect for young chefs!
          </p>
          <motion.div
            className="mt-4"
            animate={{ scale: [1, 1.1, 1] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            <Rocket className="w-8 h-8 mx-auto text-secondary opacity-75" />
          </motion.div>
        </motion.div>

        <motion.div 
          className="bg-white/90 backdrop-blur-sm p-8 rounded-xl shadow-xl"
          whileHover={{ y: -5, scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <div className="relative mb-6">
            <div className="absolute -top-12 left-1/2 transform -translate-x-1/2">
              <motion.div
                animate={{ y: [0, -5, 0] }}
                transition={{ duration: 2, repeat: Infinity, delay: 0.6 }}
                className="w-16 h-16 bg-accent rounded-full flex items-center justify-center shadow-lg"
              >
                <span className="text-3xl">3️⃣</span>
              </motion.div>
            </div>
          </div>
          <h3 className="text-xl font-bold mb-4 text-accent-foreground">Start the Fun!</h3>
          <p className="text-gray-600">
            Follow along with interactive steps, learn amazing kitchen science, and create delicious memories together!
          </p>
          <motion.div
            className="mt-4"
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            <ChefHat className="w-8 h-8 mx-auto text-accent-foreground opacity-75" />
          </motion.div>
        </motion.div>
      </div>
    </motion.div>
  );
};
